import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { Checkbox } from '@mui/material';

import api from "assets/services/api";


function ModalUpdateSellsman(props) {

    const [br, setBR] = useState(false);

    const [contact, setContact] = useState(props.props.contact);
    const [name, setName] = useState(props.props.name);
    const [lastname, setLastname] = useState(props.props.lastname);
    const [address, setAddress] = useState(props.props.address);
    const [username, setUsername] = useState(props.props.username);
    const [password, setPassword] = useState('');
    const [discount, setDiscount] = useState(props.props.discount_bonification);
    const [enable, setEnable] = useState(props.props.enable);
    const { storageId } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);


    async function handleEditSellsman(e) {
        e.preventDefault();
        const response = await api.put('/sellsman/' + props.props.id, {
            contact,
            id_admin: storageId,
            username,
            password,
            name,
            lastname,
            address,
            discount_bonification: discount,
            enable: enable
        });
        if (response.status === 200) {
            props.getAllSellmans();
            props.onHide();
        } else {
            return alert(response.data.error);
        }

    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar vendedor
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleEditSellsman}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} xs={5} controlId="formUserSellsman">
                            <Form.Label>Usuário</Form.Label>
                            <Form.Control onChange={event => setUsername(event.target.value)} value={username} type="text" placeholder="Usuário do login" />
                        </Form.Group>
                        <Form.Group as={Col} xs={4} controlId="formPasswordSellsman">
                            <Form.Label>Senha</Form.Label>
                            <Form.Control onChange={event => setPassword(event.target.value)} value={password} type="password" placeholder="Senha do vendedor" />
                        </Form.Group>
                        <Form.Group as={Col} xs={2} controlId="formDiscountSellsman">
                            <Form.Label>Desconto</Form.Label>
                            <div style={{ display: 'block', justifyContent: 'center' }}>
                                <Checkbox
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    checked={discount}
                                    onChange={event => setDiscount(event.target.checked)}
                                />
                            </div>
                        </Form.Group>
                        <Form.Group as={Col} xs={1} controlId="formDisableSellsnan">
                            <Form.Label>Habilita</Form.Label>
                            <div style={{ display: 'block', justifyContent: 'center' }}>
                                <Checkbox
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    checked={enable}
                                    onChange={event => setEnable(event.target.checked)}
                                />
                            </div>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formNameSellsman">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control onChange={event => setName(event.target.value)} value={name} type="text" placeholder="Nome do vendedor" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formContactSellsman">
                            <Form.Label>Contato</Form.Label>
                            <PhoneInput
                                defaultCountry="BR"
                                className="form-control"
                                placeholder="Contato do vendedor"
                                value={contact}
                                onChange={setContact} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formAddressSellsman">
                            <Form.Label>Endereço</Form.Label>
                            <Form.Control onChange={event => setAddress(event.target.value)} value={address} type="text" placeholder="Endereço do vendedor" />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Salvar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Vendedor editado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateSellsman;